const ExpertProfile = () => (
  <section className="py-24 bg-[#0F1419]" data-testid="expert-profile">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Built by Anglers Who Know the Water</h2>
        <p className="text-xl text-slate-400 max-w-3xl mx-auto">
          FlyFinder was created by experienced fly fishers with decades of combined on-water experience across North America
        </p>
      </div>
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="space-y-6 text-lg text-slate-400">
            <p>
              <strong className="text-white">We've been where you are.</strong> Standing in a river at 6 AM, trying to decide between a #16 Adams or a #18 BWO. Watching fish rise and wondering what they're eating. Driving two hours to a famous stream only to find the hatch you hoped for isn't happening.
            </p>
            <p>
              <strong className="text-white">That's why we built FlyFinder.</strong> We combined decades of field experience—from the freestone rivers of the Rockies to the technical spring creeks of Montana, from Great Lakes tributaries to remote Canadian wilderness—with real-time environmental data.
            </p>
            <p>
              <strong className="text-white">Our credentials:</strong>
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>20+ years guiding experience across Western Canada and the U.S.</li>
              <li>Certified entomology and aquatic insect identification training</li>
              <li>Contributors to regional fly fishing publications</li>
              <li>Thousands of hours documenting hatch patterns and water conditions</li>
            </ul>
            <p className="text-slate-300 italic">
              "This isn't an algorithm guessing. It's our knowledge, refined by thousands of days on the water, accessible from your pocket." — FlyFinder Team
            </p>
          </div>
        </div>
        <div className="relative">
          <img 
            src="https://customer-assets.emergentagent.com/job_angler-connect/artifacts/blu6lxzy_IMG_20251228_130402.jpg"
            alt="Experienced angler releasing trout in mountain waters"
            className="rounded-2xl shadow-2xl"
          />
          <div className="absolute -bottom-6 -right-6 bg-[#137dc5] text-white p-6 rounded-xl shadow-xl max-w-xs">
            <p className="font-bold text-lg mb-2">Real Experience. Real Results.</p>
            <p className="text-cyan-100 text-sm">Field-tested on waters from Alaska to Pennsylvania</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ExpertProfile;
